import React, { Fragment } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import PropType from 'prop-types'
import Swal from 'sweetalert2'

import Dashboard from '@wrappers/Dashboard'
import { Title } from '@lib'
import NoticeForm from '@shared/NoticeForm'

const Content = ({ user }) => {
  const { id } = useParams()
  const navigate = useNavigate()

  const handleSave = () => {
    Swal.fire({
      text: 'Notice updated!',
      icon: 'success',
      showConfirmButton: false,
      timer: 3000
    })

    navigate('/settings/notices-and-release-notes#notices')
  }

  return (
    <Fragment>

      <Title text='Edit Notice' user={user} />

      <NoticeForm
        id={id}
        onSave={handleSave}
      />
    </Fragment>
  )
}

Content.propTypes = {
  user: PropType.object
}

const EditNotice = () => {
  return (
    <Dashboard>
      <Content />
    </Dashboard>
  )
}

export default EditNotice
